import { Pipe, PipeTransform } from '@angular/core';
import { AutomationRule } from '../interfaces/automation-rule.interface';

@Pipe({name: 'ruleIsSelected'})
export class RuleIsSelectedPipe implements PipeTransform {
  transform(rule: AutomationRule, selectedAutomationRuleIds: string[]): boolean {
    return selectedAutomationRuleIds.includes(rule.id);
  }
}
